(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const loadMoreControlsSelector = '[data-collection-load-more]';
  const loadMoreButtonSelector = '[data-load-more-button]';
  const productCardSelector = '.product-grid__item';
  const preloadMargin = Math.max(1800, Math.round(window.innerHeight * 2.25));
  const highPriorityMargin = Math.max(550, Math.round(window.innerHeight * 0.8));

  window.__dnaProductImageObserver?.disconnect();
  window.__dnaProductHighPriorityObserver?.disconnect();
  window.__dnaProductMutationObserver?.disconnect();

  const productImageObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!(entry.target instanceof HTMLElement)) return;

      const card = entry.target;
      card.classList.toggle('product-grid__item--preload-zone', entry.isIntersecting);
      if (!entry.isIntersecting) return;

      const image = card.querySelector('[data-card-gallery-swap-stage] img');
      if (!(image instanceof HTMLImageElement)) return;

      image.loading = 'eager';
      image.fetchPriority = 'low';
    });
  }, { rootMargin: `${preloadMargin}px 0px` });

  const productHighPriorityObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || !(entry.target instanceof HTMLElement)) return;

      const image = entry.target.querySelector('[data-card-gallery-swap-stage] img');
      if (!(image instanceof HTMLImageElement)) return;

      image.loading = 'eager';
      image.fetchPriority = 'high';
      image.decode().catch(() => {});
    });
  }, { rootMargin: `${highPriorityMargin}px 0px` });

  function observeProductCards(root = document) {
    if (root instanceof HTMLElement && root.matches(productCardSelector)) {
      productImageObserver.observe(root);
      productHighPriorityObserver.observe(root);
    }
    root.querySelectorAll?.(productCardSelector).forEach((card) => {
      productImageObserver.observe(card);
      productHighPriorityObserver.observe(card);
    });
  }

  function startProductImagePreloading() {
    observeProductCards();

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) observeProductCards(node);
        });
      });
    });
    const resultsRoot = document.querySelector('results-list');
    if (resultsRoot) mutationObserver.observe(resultsRoot, { childList: true, subtree: true });

    window.__dnaProductImageObserver = productImageObserver;
    window.__dnaProductHighPriorityObserver = productHighPriorityObserver;
    window.__dnaProductMutationObserver = mutationObserver;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startProductImagePreloading, { once: true });
  } else {
    startProductImagePreloading();
  }

  function setLoadMoreState(button, loading) {
    button.disabled = loading;
    button.setAttribute('aria-busy', String(loading));
    button.querySelector('[data-load-more-label]')?.toggleAttribute('hidden', loading);
    button.querySelector('[data-load-more-loading]')?.toggleAttribute('hidden', !loading);
  }

  async function loadMoreProducts(button) {
    const controls = button.closest(loadMoreControlsSelector);
    const resultsList = button.closest('results-list');
    const grid = resultsList?.querySelector('[data-testid="product-grid"]');
    const nextUrl = controls?.dataset.nextUrl;
    const error = controls?.querySelector('[data-load-more-error]');

    if (!(controls instanceof HTMLElement) || !(grid instanceof HTMLUListElement) || !nextUrl || button.disabled) return;

    error?.toggleAttribute('hidden', true);
    setLoadMoreState(button, true);

    try {
      const response = await fetch(nextUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Load more failed: ${response.status}`);

      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = page.querySelector('[data-testid="product-grid"]');
      const nextControls = page.querySelector(loadMoreControlsSelector);
      if (!(nextGrid instanceof HTMLUListElement) || !(nextControls instanceof HTMLElement)) {
        throw new Error('The next product page is missing its grid');
      }

      const newCards = Array.from(nextGrid.children).filter((card) => card.matches('.product-grid__item'));
      if (newCards.length === 0) throw new Error('The next product page has no cards');

      const fragment = document.createDocumentFragment();
      newCards.forEach((card) => fragment.append(card));
      grid.append(fragment);

      if (nextControls.dataset.nextUrl) {
        controls.dataset.nextUrl = nextControls.dataset.nextUrl;
        setLoadMoreState(button, false);
      } else {
        delete controls.dataset.nextUrl;
        button.remove();
      }
    } catch (loadError) {
      console.error(loadError);
      error?.toggleAttribute('hidden', false);
      setLoadMoreState(button, false);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(loadMoreButtonSelector);
    if (!(button instanceof HTMLButtonElement)) return;
    loadMoreProducts(button);
  });

  } catch(e) { console.error(e); }
})();
})();
